import script from "./code-load-edit-form.vue?vue&type=script&setup=true&lang=js"
export * from "./code-load-edit-form.vue?vue&type=script&setup=true&lang=js"

import "./code-load-edit-form.vue?vue&type=style&index=0&id=68950e54&lang=css"

const __exports__ = script;

export default __exports__